module.exports = __webpack_public_path__ + "Flag-132.b1f5b40a46704c4af78b50bd1a5e394a.svg";